import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

import { automationsPaths } from 'Automations/router'

export const useRegeneratePdfAction = ({
  quoteId,
  quoteVariantId
}: {
  quoteId: string
  quoteVariantId?: string
}) => {
  const { displayNotification } = useNotifications()
  const navigate = useNavigate()

  const regenerateMutation = useMutation(
    dashboard20240730Client.postQuoteRegeneratePdf
  )

  const regeneratePdf = useCallback(async () => {
    try {
      await regenerateMutation.mutateAsync({ id: quoteId, quoteVariantId })
      displayNotification('PDF generated', { type: 'success' })
      navigate(automationsPaths.manualTasksInbox())
    } catch {
      displayNotification('Failed to regenerate PDF', { type: 'error' })
    }
  }, [
    regenerateMutation,
    quoteId,
    quoteVariantId,
    displayNotification,
    navigate
  ])

  return { regeneratePdf, isPending: regenerateMutation.isPending }
}
